import {Brick, CloudObject, ErrorFlow, registerBrick} from 'olympe';
/**
 * This brick handles deletion of objects from the local data cloud.
 */
export default class DeleteFromLocalDataCloud extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string[] | CloudObject} objects
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [objects], [forwardEvent, setErrorFlow]) {
        if (!Array.isArray(objects)) {
            objects = [objects];
        }

        if (objects.length === 0) {
            setErrorFlow(ErrorFlow.create('No objects to delete', 500));
            return;
        }

        let tagsToDelete = objects;

        if (objects[0] instanceof CloudObject) {
            tagsToDelete = objects.map((object) => object.getTag());
        }

        for (const tag of tagsToDelete) {
            globalThis.db.get(tag).e = false;
        }
        forwardEvent();
    }
}

registerBrick('0197cecd44865b430826', DeleteFromLocalDataCloud);
